// src/utils/operatorInvoice.js
// Facturas del operador que NO salen de un cheque: el operador las arma a mano
// (servicio + monto, varias líneas) y se suman a su deuda en `operatorDebts`.
// `source` distingue el origen de cada deuda:
//   check    — la tarifa automática por cheque (deudas viejas no traen source).
//   custom   — factura personalizada creada en el panel.
//   contract — $3.50 por cada contrato creado (el componente de contratos
//              llamará a createContractInvoice).
//   client_invoice — los $5 por cada factura personalizada a un cliente
//              (utils/clientInvoice.js), igual que la tarifa por cheque.
// Ninguna de ellas depende de un cheque: la auditoría de deudas prematuras
// y el ajuste de tarifa deben dejarlas en paz.
// El operador siempre cobra a CSR: sus facturas van a nombre de CSR.

export const DEBT_SOURCES = { CHECK: 'check', CUSTOM: 'custom', CONTRACT: 'contract', CLIENT_INVOICE: 'client_invoice' };

export const CSR_BILLING_NAME = 'CSR Claims Assistant LLC';

// Solo el operador puede borrar deudas del operador (también en firestore.rules,
// función isOperator(); cámbialo en los dos sitios).
export const OPERATOR_EMAIL = 'josejledezma.a@gmail.com';
export const isOperator = email => String(email || '').toLowerCase() === OPERATOR_EMAIL;
export const CONTRACT_FEE = 3.5;

export const OPERATOR_INVOICE_PREFIX = 'OP-';
export const OPERATOR_INVOICE_START = 1001;

export const debtSource = debt => debt?.source || DEBT_SOURCES.CHECK;
export const isManualDebt = debt => debtSource(debt) !== DEBT_SOURCES.CHECK;
// Las que tienen su propia factura del operador (para ver/descargar).
export const hasOperatorInvoice = debt => [DEBT_SOURCES.CUSTOM, DEBT_SOURCES.CONTRACT].includes(debtSource(debt));

export const formatOperatorInvoiceNumber = seq => `${OPERATOR_INVOICE_PREFIX}${seq}`;

const toCents = value => Math.round((Number(String(value ?? '').replace(/[$,\s]/g, '')) || 0) * 100);

// Limpia las líneas del formulario: descarta las vacías, redondea a centavos.
export const normalizeInvoiceItems = (items = []) => items
  .map(item => ({ service: String(item.service || '').trim(), amount: toCents(item.amount) / 100 }))
  .filter(item => item.service || item.amount);

export const invoiceTotal = (items = []) => normalizeInvoiceItems(items).reduce((cents, item) => cents + toCents(item.amount), 0) / 100;

// Devuelve la lista de problemas (vacía = se puede guardar).
export const validateInvoiceItems = (items = []) => {
  const clean = normalizeInvoiceItems(items);
  const errors = [];
  if (!clean.length) errors.push('empty');
  if (clean.some(item => !item.service)) errors.push('missing_service');
  if (clean.some(item => !(item.amount > 0))) errors.push('invalid_amount');
  return errors;
};
